module.exports = __webpack_public_path__ + "img/设计单.c7666076.png";